import React, {useContext, useEffect, useState} from "react";
import TreeContainer from "../../../components/tree/TreeContainer";
import {TranslateContext} from "../../../context/TranslateContext";
import {MobileContext} from "../../../context/MobileContext";
import {
    deleteStrutturaClasseTipoImpExpDatiApi,
    getStrutturaClassiTipiImpExpDatiApi
} from "../services/TipiImpExpDatiServices";
import ConfStrutturaClassiImpExpView from "./ConfStrutturaClassiImpExpView";

export default function ConfStrutturaClassiImpExpController() {

    const [loadingData, setLoadingData] = useState(true);

    const [data, setStrutture] = useState([]);
    const [albero, setAlbero] = useState([]);
    const [strImpExpSel, setStrImpExpSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');

    const {translate} = useContext(TranslateContext);
    const {isMobile} = useContext(MobileContext);

    async function getStrutturaClassiTipiImpExpDati() {
        const response = await getStrutturaClassiTipiImpExpDatiApi();
        setStrutture(response.data.data?.lista);
        setAlbero(response.data.data?.albero);
        setLoadingData(false);
    }

    useEffect(() => {
        if (loadingData) {
            getStrutturaClassiTipiImpExpDati();
        }
    }, []);

    const eliminaStrClasse = async () => {
        setShowConfirm(false);
        const response = await deleteStrutturaClasseTipoImpExpDatiApi(strImpExpSel.id_struttura_classe_tipo_imp_exp);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setStrutture(response.data.data?.lista);
            setAlbero(response.data.data?.albero);
        }
    }

    function getAlberoStruttura() {
        return (
            <TreeContainer
                data={albero}
                idSelected={''}
                onClickItem={() => {
                }}
                getLabel={(elemento) => elemento.descrizione}
                getFigli={(elemento) => elemento.figli}
                icona={(elemento) => <i className={elemento.icona}/>}
            />
        );
    }

    function onClickElimina(row) {
        setStrImpExpSel(row)
        setShowConfirm(true);
    }

    return (
        !loadingData &&
        <ConfStrutturaClassiImpExpView
            showConfirm={showConfirm}
            setShowConfirm={setShowConfirm}
            show={show}
            eliminaStrClasse={eliminaStrClasse}
            modalMsg={modalMsg}
            data={data}
            setShow={setShow}
            translate={translate}
            isMobile={isMobile}
            getAlberoStruttura={getAlberoStruttura}
            strImpExpSel={strImpExpSel}
            onClickElimina={onClickElimina}
        />
    );
}